import {
  FeaturedJob,
  FeaturedJobAPI,
  FeaturedSearchJob,
  FeaturedSearchJobFlat,
  flatFeaturedJob,
} from "../../types/featuredJobList";

declare const jobData: any; // from localized
const currentLang = jobData.currentLang; // from localized
const featuredJobsData: FeaturedJobAPI = jobData.featuredJobsData;

export class FeaturedData {
  private featuredJobsData: FeaturedJobAPI;
  constructor() {
    this.featuredJobsData = {
      filter: [],
      search: [],
    };
  }

  /**
   * Loads all featured jobs from the REST API. {site_url/wp-json/options/all}
   * @returns {Promise<void>}
   */
  loadFeaturedJobs(): void {
    console.log("featuredJobsData", featuredJobsData);
    this.featuredJobsData = featuredJobsData;
    // try {
    //   const response = await fetch("/wp-json/options/all");
    //   if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    //   const data = await response.json();

    //   this.featuredJobsData = data;
    // } catch (error) {
    //   console.error("Fehler beim Laden der Featured Jobs:", error);
    // }
  }

  /**
   * Returns all featured jobs Conditions (filter) in a flat format.
   */
  getFeaturedFilterData(): flatFeaturedJob[] {
    const filterData = this.featuredJobsData["filter"];
    if (!Array.isArray(filterData)) {
      console.error("Expected 'filter' to be an array.");
      return [];
    }
    console.log("FILTER DATA", filterData);
    return this.transformFeaturedJobsToFlatCategories(filterData);
  }

  getFeaturedSearchData(): FeaturedSearchJobFlat[] {
    const searchData = this.featuredJobsData["search"];
    if (!Array.isArray(searchData)) {
      console.log("Featured 'search' is not set.");
      return [];
    }

    return this.transformFeaturedSearchDataToFlat(searchData);
  }

  /**
   * Transforms the featured search jobs into a flat format.
   * @returns {FeaturedSearchJobFlat[]}
   */
  transformFeaturedSearchDataToFlat(searchData: FeaturedSearchJob[]): FeaturedSearchJobFlat[] {
    return searchData.map((job) => {
      const paramSet = new Set<string>();

      job.query_repeater?.forEach((entry: any) => {
        const param = entry.parameter;
        if (typeof param === "string" && param.trim() !== "") {
          paramSet.add(param.toLowerCase());
        }
      });

      return {
        job_id: job.job_id,
        parameters: Array.from(paramSet),
      };
    });
  }

  /**
   * Transforms the featured jobs into a flat format.
   * @returns {flatFeaturedJob[]}
   */
  private transformFeaturedJobsToFlatCategories(filterData: FeaturedJob[]): flatFeaturedJob[] {
    return filterData.map((job) => {
      const categorySet = new Set<string>();

      job.top_category_repeater.forEach((group: any) => {
        const relevantKey = this.getRelevantCategoryKey(group.filter_type);
        if (!relevantKey) return;

        group.category_repeater.forEach((category: any) => {
          const value = category[relevantKey];
          if (typeof value === "string" && value.trim() !== "" && value.trim() !== "0") {
            categorySet.add(value.toLowerCase());
          }
        });
      });

      return {
        job_id: job.job_id,
        categories: Array.from(categorySet),
      };
    });
  }

  /**
   * Maps a filter_type to the corresponding category key.
   */
  private getRelevantCategoryKey(filterType: string): string | null {
    console.log("currentLang", currentLang);
    switch (filterType) {
      case "workingTimes":
        if (currentLang === "de") return "category_working";
        else {
          return "category_working_en";
        }
      case "jobLevel":
        if (currentLang === "de") return "category_joblevel";
        else {
          return "category_joblevel_en";
        }
      case "jobOpening":
        if (currentLang === "de") return "category_opening";
        else return "category_opening_en";
      default:
        return null;
    }
  }
}
